import { IconProps } from "@tfg/ui"

type Props = IconProps

export const IconFootwearFinishing = ({ size = 24, ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 30 16"
    fill="none"
    {...props}
  >
    <path
      d="M15.4966 4.95754C15.7863 5.42773 16.4023 5.57403 16.8725 5.28431C17.3427 4.99459 17.489 4.37857 17.1993 3.90838L15.4966 4.95754ZM14.0625 2.63011L15.4966 4.95754L17.1993 3.90838L15.7652 1.58095L14.0625 2.63011Z"
      fill="black"
    />
    <path
      d="M13.2702 5.96718C13.56 6.43737 14.176 6.58367 14.6462 6.29396C15.1164 6.00424 15.2627 5.38821 14.9729 4.91802L13.2702 5.96718ZM11.8361 3.63975L13.2702 5.96718L14.9729 4.91802L13.5389 2.59059L11.8361 3.63975Z"
      fill="black"
    />
    <path
      d="M11.0673 6.6727C11.3436 7.1509 11.9553 7.31458 12.4335 7.03828C12.9117 6.76198 13.0753 6.15034 12.7991 5.67214L11.0673 6.6727ZM9.84484 4.55686L11.0673 6.6727L12.7991 5.67214L11.5766 3.5563L9.84484 4.55686Z"
      fill="black"
    />
    <path
      d="M28.9803 5.44324C25.1012 5.44324 22.7502 9.20474 22.7502 11.203"
      stroke="black"
      strokeWidth="1.99999"
    />
    <path
      d="M4.80493 6.19519C5.88638 9.65107 10.6823 7.20609 17.9938 11.3673"
      stroke="black"
      strokeWidth="1.99999"
    />
    <path
      d="M20.9843 3.42188C20.326 4.71489 17.7635 7.81813 13.3672 9.29922"
      stroke="black"
      strokeWidth="1.99999"
    />
    <path
      d="M27.4484 11.0855C28.3888 11.0855 28.9765 10.3567 28.9765 9.74548L28.9969 2.57821C28.9986 1.97975 28.5139 1.4937 27.9155 1.4937H27.2368C26.9771 1.4937 26.7666 1.70412 26.7666 1.9638V3.06882C26.7666 4.38535 22.1816 3.76293 20.8886 3.76293C20.2272 3.10159 19.6327 2.08439 18.7059 1.12293C18.63 1.04414 18.5235 1.00325 18.4145 1.01324C14.3569 1.38499 9.46323 5.84847 4.43241 6.24259C4.38539 6.24259 1 6.54821 1 9.29881C1 12.6136 26.508 11.0855 27.4484 11.0855Z"
      stroke="black"
      strokeWidth="1.99999"
    />
    <path
      d="M28.8917 10.1792V14.0528C28.8917 14.1578 28.8065 14.243 28.7014 14.243H10.4243C6.53518 14.243 1.16675 12.5445 1.16675 9.76514"
      stroke="black"
      strokeWidth="2.02301"
    />
  </svg>
)
